import * as types from "./actionTypes";

export const latestJobsSetIsLoading = (isLoading) => ({
  type: types.LATEST_JOBS_SET_IS_LOADING,
  payload: isLoading,
});

export const latestJobsSetData = ({ latestJobs }) => ({
  type: types.LATEST_JOBS_SET_DATA,
  payload: { latestJobs },
});

export const latestJobsRequestData = (latitude, longitude) => ({
  type: types.LATEST_JOBS_REQUEST_DATA,
  payload: { latitude, longitude },
});
